import { Button, Flex, Text } from '@lideralia/alife-uikit';
import { PendantJewelry } from '@lideralia/alife-uikit/dist/atoms/imgs';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ServiceProductJewelryStore = ({
  product,
  company,
  onSelect,
  onFingerprintBlock,
  buttonDisabled,
}) => {
  const handleSelect = () => {
    if (product.needs_line_fingerprint && !product.has_line_fingerprint) {
      onFingerprintBlock();
    } else {
      onSelect(product);
    }
  };

  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        overflow: 'hidden',
        display: 'grid',
        rowGap: '12px',
        padding: '16px',
      }}
    >
      {/* Image */}
      <div style={{ position: 'relative' }}>
        {product.image ? (
          <img
            src={product.image}
            alt={product.name}
            style={{
              width: '100%',
              aspectRatio: '204 / 180',
              objectFit: 'cover',
              marginBottom: '16px',
              borderRadius: '18px',
              display: 'block',
            }}
          />
        ) : (
          <div
            style={{
              width: '100%',
              paddingTop: '100%',
              backgroundColor: '#f5f5f5',
              borderRadius: '18px',
              position: 'relative',
            }}
          >
            <div
              style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <PendantJewelry width={64} height={64} />
            </div>
          </div>
        )}
      </div>

      {/* Name + Price */}
      <Flex alignItems="center" justifyContent="space-between" flexWrap="wrap" gap="4px">
        <Text color="black96" sizeText="display14" fontWeight="bold" flex="1">
          {product.name}
        </Text>
        {(() => {
          const { variable_pricings: pricings, currency } = product;
          const color = company?.style?.primaryColor || '#007AFF';
          if (pricings?.length > 0) {
            const totals = pricings.map((v) => v.total).filter((t) => t > 0);
            if (totals.length === 0) return null;
            const min = Math.min(...totals);
            const max = Math.max(...totals);
            return (
              <Text sizeText="display14" fontWeight="bold" style={{ color, whiteSpace: 'nowrap' }}>
                {min === max ? (
                  `${min}${currency}`
                ) : (
                  <FormattedMessage id="serviceProducts.priceFrom" values={{ min, currency }} />
                )}
              </Text>
            );
          }
          if (product.total > 0) {
            return (
              <Text sizeText="display14" fontWeight="bold" style={{ color, whiteSpace: 'nowrap' }}>
                {product.total}
                {currency}
              </Text>
            );
          }
          return null;
        })()}
      </Flex>

      {/* Button */}
      <div>
        {!!product.call_to_action && (
          <Button
            backgroundColor={company?.style?.primaryColor || '#007AFF'}
            color={company?.style?.textColor || 'white'}
            variant="primary"
            width="100%"
            onClick={handleSelect}
            disabled={buttonDisabled}
          >
            <FormattedMessage id="serviceProducts.selectProduct" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default ServiceProductJewelryStore;
